// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}


/* index.css or global.css */
:root {
  --bg-color-light: #D6BBFB; /* Your background color */
}

/* Use the variable for global styles */
body {
  background-color: var(--bg-color-light);
}

.card {
  background-color: var(--bg-color);
}

/* index.css or global.css */
.bg-color {
  background-color: var(--bg-color-light);
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;;AAGA,4BAA4B;AAC5B;EACE,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA,uCAAuC;AACvC;EACE,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,4BAA4B;AAC5B;EACE,uCAAuC;AACzC","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n\n/* index.css or global.css */\n:root {\n  --bg-color-light: #D6BBFB; /* Your background color */\n}\n\n/* Use the variable for global styles */\nbody {\n  background-color: var(--bg-color-light);\n}\n\n.card {\n  background-color: var(--bg-color);\n}\n\n/* index.css or global.css */\n.bg-color {\n  background-color: var(--bg-color-light);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
